module.exports = __webpack_public_path__ + "img/multi_devices.6e841a47.svg";